import React from 'react';
import { Search, Filter } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

const EmailActivityFilters = ({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  days,
  setDays,
  hideTest,
  setHideTest,
  categories,
  categoryFilter,
  setCategoryFilter,
}) => {
  return (
    <Card>
      <CardHeader className="pb-3 flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-slate-100 text-base flex items-center gap-2">
          <Filter className="h-4 w-4" /> Filters
        </CardTitle>
        <div className="flex items-center gap-2" data-testid="hide-test-traffic-control">
          <Label
            htmlFor="hide-test-toggle"
            className="text-xs text-slate-300 cursor-pointer select-none"
          >
            Hide test traffic
          </Label>
          <Switch
            id="hide-test-toggle"
            checked={hideTest}
            onCheckedChange={setHideTest}
            data-testid="hide-test-traffic-toggle"
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <div className="relative md:col-span-2">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <Input
              placeholder="Search recipient or subject..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-9 bg-[#0F1730] border-[#2A3658] text-slate-100"
              data-testid="email-activity-search"
            />
          </div>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="bg-[#0F1730] border-[#2A3658] text-slate-100" data-testid="email-activity-status-filter">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="border-[#2A3658]">
              <SelectItem value="all">All statuses</SelectItem>
              <SelectItem value="success">Successful only</SelectItem>
              <SelectItem value="failed">Failed only</SelectItem>
            </SelectContent>
          </Select>
          <Select value={String(days)} onValueChange={(v) => setDays(Number(v))}>
            <SelectTrigger className="bg-[#0F1730] border-[#2A3658] text-slate-100" data-testid="email-activity-days-filter">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="border-[#2A3658]">
              <SelectItem value="1">Last 24h</SelectItem>
              <SelectItem value="7">Last 7 days</SelectItem>
              <SelectItem value="30">Last 30 days</SelectItem>
              <SelectItem value="90">Last 90 days</SelectItem>
              <SelectItem value="365">Last 365 days</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {categories.length > 0 && (
          <div className="mt-3 flex items-center gap-2 flex-wrap">
            <span className="text-xs text-slate-500">Category:</span>
            <Button
              size="sm"
              variant={categoryFilter === 'all' ? 'default' : 'outline'}
              onClick={() => setCategoryFilter('all')}
              className={`text-xs h-7 ${
                categoryFilter === 'all'
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'border-[#2A3658] bg-transparent text-slate-300 hover:bg-[#131C3A]'
              }`}
              data-testid="email-activity-category-all"
            >
              All
            </Button>
            {categories.map((c) => (
              <Button
                key={c}
                size="sm"
                variant={categoryFilter === c ? 'default' : 'outline'}
                onClick={() => setCategoryFilter(c)}
                className={`text-xs h-7 ${
                  categoryFilter === c
                    ? 'bg-red-600 hover:bg-red-700 text-white'
                    : 'border-[#2A3658] bg-transparent text-slate-300 hover:bg-[#131C3A]'
                }`}
                data-testid={`email-activity-category-${c}`}
              >
                {c}
              </Button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default EmailActivityFilters;
